import { AuthLayout } from '../../../layouts/auth-layout';
import { TwoFactorSetupSuccess } from '../../../features/auth/TwoFactorSetupSuccess';
import { Helmet } from 'react-helmet';

export const TwoFactorSetupSuccessPage = () => {
  return (
    <AuthLayout>
      <Helmet>
        <title>Splashworks: Two Factor Setup</title>
      </Helmet>
      <TwoFactorSetupSuccess />
    </AuthLayout>
  );
};
